module.exports = __webpack_public_path__ + "img/glow_pack.db77b37a.png";